import React, { FC } from 'react';
import { SettingsFormPageSkeleton, SettingsTablePageSkeleton } from '../../settings/settingsSkeleton';

export const ConnectorRulesPageSkeleton: FC = () => <SettingsTablePageSkeleton />;
export const ConnectorRulePageSkeleton: FC = () => <SettingsFormPageSkeleton />;
